/** @jsxImportSource @emotion/react */
import React from 'react'
import { BannerForm, BannerPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/BannerContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, bannersManagement } = breadcrumbItems

const BannerCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <BannerForm />
        </div>
        <div css={styles.right}>
          <BannerPreview />
        </div>
      </div>
    </Provider>
  )
}

export default BannerCreate;
